module.exports = __webpack_public_path__ + "static/media/blog-optimized.3988f470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/99-conclusion/images/blog-optimized.jpg
// module id = 984
// module chunks = 0